import { Shimmer } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import { CweDetail } from 'types';

/**
 * UI for rendering the CWE field on the CVE details page's title card.
 */
export const CweDetailsListValue = ({
  cweDetailsList,
  loading,
}: {
  cweDetailsList?: CweDetail[];
  loading?: boolean;
}) => {
  const [t] = useTranslation(['vulnerability']);
  if (
    cweDetailsList === undefined ||
    cweDetailsList === null ||
    cweDetailsList?.length < 1
  ) {
    return null;
  }

  const parentLabel = t('cweWeaknesses.weakness', {
    defaultValue: 'Weakness',
    ns: 'vulnerability',
  });
  const isMultiple = cweDetailsList.length > 1;

  return (
    <dl
      style={{
        // Render vertically if there are multiple CWEs
        ...(isMultiple && {
          marginTop: '1em',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
        }),
      }}
    >
      <dt>{parentLabel}</dt>
      <dd>
        <Shimmer styles={{ root: { minWidth: '8em' } }} isDataLoaded={!loading}>
          <CweDetailsList
            cweDetailsList={cweDetailsList}
            isMultiple={isMultiple}
          />
        </Shimmer>
      </dd>
    </dl>
  );
};

/**
 * Render a list of structured CWE items.
 */
const CweDetailsList = ({
  cweDetailsList,
  isMultiple,
}: {
  cweDetailsList: CweDetail[];
  isMultiple: boolean;
}) => {
  if (!isMultiple) {
    return <CweDetailsListRow cweItem={cweDetailsList[0]} />;
  }
  return (
    <ol style={{ paddingLeft: '14px', marginBottom: '0px' }}>
      {cweDetailsList?.map((cweDetail, index) => (
        <li key={index} style={{ paddingBottom: '1rem' }}>
          <CweDetailsListRow cweItem={cweDetail} />
        </li>
      ))}
    </ol>
  );
};

/**
 * Render a single CWE item.
 */
const CweDetailsListRow = ({ cweItem }: { cweItem: CweDetail | string }) => {
  if (typeof cweItem === 'string') {
    return <>{cweItem}</>;
  }

  const [cwe, cweUrl] = cweItem.values;
  return <a href={cweUrl}>{cwe}</a>;
};
